package com.fireavert.react.shared.components.nav

import com.fireavert.react.shared.styles.ModernNavStyles
import emotion.css.cx
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.span

external interface ModernNavItemProps: Props {
    var onClick: () -> Unit
    var isActive: Boolean
    var iconPath: String
    var text: String
    var badgeCount: Int?
    var isCollapsed: Boolean
}

val ModernNavItem = FC<ModernNavItemProps> { props ->
    div {
        className = cx(
            ModernNavStyles.navItem,
            if (props.isActive) ModernNavStyles.navItemActive else null
        )
        onClick = { props.onClick() }

        img {
            src = props.iconPath
            alt = "${props.text} icon"
            className = ModernNavStyles.navItemIcon
        }

        if (!props.isCollapsed) {
            span {
                className = ModernNavStyles.navItemText
                +props.text
            }
            props.badgeCount?.let { count ->
                if (count > 0) {
                    span {
                        className = cx(
                            ModernNavStyles.navItemBadge,
                            if (props.isActive) ModernNavStyles.navItemBadgeActive else null
                        )
                        +count.toString()
                    }
                }
            }
        } else if (props.badgeCount != null && props.badgeCount!! > 0) {
            span {
                className = ModernNavStyles.navItemMiniBadge
                +"•"
            }
        }
    }
}